import i18next from "i18next";
import HttpApi from "i18next-http-backend"; // fallback xhr load
import Backend from "i18next-chained-backend";
import LocalStorageBackend from "i18next-localstorage-backend"; // primary use cache
import { CURRENT_LANGUAGE, DEFAULT_LANGUAGE } from "./constants";
import { initReactI18next } from "react-i18next";
import { toMapFn } from "~/common/utils/reducers";
import { resolveApiUrl } from "~/utils/url/urlResolver";

const instance = i18next.use(Backend).use(initReactI18next);

const availableLanguages = [
  "en",
  "es",
  "it",
  "pt",
  "fr",
  "de",
  "zh",
  "zh_TW",
  "ja",
  "sk",
  "ro",
  "hu",
  "cz",
  "bg",
  "ko",
];
const cacheBuster = window.SCHA.config?.cacheBuster ?? 1;

const baseUrl = window.SCHA.config.baseTranslationsUrl;
const loadPath = (languages: string[], namespaces: string[]) => {
  const lng = languages[0];
  const namespace = namespaces[0];
  if (namespace === "translations") {
    return `${baseUrl}/translations/${lng}.json?v=${cacheBuster}`;
  }
  return resolveApiUrl(`/translations/${namespace}?l=${lng}&v=${cacheBuster}`);
};

const backends = [];
const backendOptions = [];

// if (import.meta.env.PROD) {
// TODO - Disable local storage of translations until we have a "semi prod mode" for lower enivornments
// eslint-disable-next-line
if (false) {
  const versions = toMapFn(
    availableLanguages,
    (lng) => lng,
    () => cacheBuster,
  );

  backends.push(LocalStorageBackend);
  backendOptions.push({
    expirationTime: 24 * 60 * 60 * 1000,
    versions,
  });
}
backends.push(HttpApi);
backendOptions.push({
  loadPath: loadPath,
});

instance.init({
  backend: {
    backends,
    backendOptions,
  },

  fallbackLng: DEFAULT_LANGUAGE,
  lng: CURRENT_LANGUAGE,
  // fallbackLng: 'en',
  // lng: 'es-br',
  // lowerCaseLng: true,

  // have a common namespace used around the full app
  ns: ["translations"],
  defaultNS: "translations",

  debug: false,
  load: "all",

  interpolation: {
    escapeValue: false, // not needed for react!!
  },

  react: {
    useSuspense: true,
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ["br", "strong", "i", "b", "em ", "p", "a", "sub", "sup"],
  },

  pluralSeparator: ":::",
  contextSeparator: ":::",

  nsSeparator: false,
});

// @ts-expect-error -> t function that gets passed for kameleeon a/b functions. TODO: Typing
window.t = instance.getFixedT(CURRENT_LANGUAGE, "translations");

export default instance;
